
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 11","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.121 1.129a2.94 2.94 0 01.86 1.777c.078.703-.118 1.406-.547 2.11l-2.559.859h1.914l-.918.918L5 7.75h1.914a4.02 4.02 0 01-1.68.977C4.688 8.922 4.102 9 3.477 9c-.547 0-.997-.059-1.387-.176L.8 10.114a.458.458 0 01-.331.136c-.137 0-.254-.04-.332-.137C.039 10.035 0 9.918 0 9.781c0-.117.04-.234.137-.332l5.078-5.058a.41.41 0 00.078-.215.406.406 0 00-.098-.235.314.314 0 00-.215-.097.314.314 0 00-.214.097L1.27 7.418a5.606 5.606 0 01.136-2.05c.196-.821.567-1.524 1.114-2.071l1.68-1.66C4.765 1.07 5.37.68 5.995.445 6.582.25 7.13.211 7.676.328c.547.117 1.015.39 1.445.8z"}})])
          )
        }
      }
    